import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { registerUserEmail } from '../utils/sharingStorage';
import { getOrCreateAccount } from '../utils/accountStorage';

const AuthContext = createContext(null);

const DEFAULT_ACCOUNT = { tier: 'basic', scanCreditsExtra: 0, isAdmin: false };

export function AuthProvider({ children }) {
  const [user,    setUser]    = useState(undefined); // undefined = loading
  const [account, setAccount] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) {
        registerUserEmail(firebaseUser.uid, firebaseUser.email, firebaseUser.displayName);
        // Set defaults immediately so the UI doesn't wait on the Firestore fetch
        setAccount(DEFAULT_ACCOUNT);
        const realAccount = await getOrCreateAccount(firebaseUser.uid);
        setAccount(realAccount || DEFAULT_ACCOUNT);
      } else {
        setAccount(null);
      }
    });
    return unsubscribe;
  }, []);

  const logout = () => signOut(auth);

  // Call this after an admin updates the current user's account doc
  const refreshAccount = useCallback(async () => {
    if (!user) return;
    const fresh = await getOrCreateAccount(user.uid);
    setAccount(fresh || DEFAULT_ACCOUNT);
  }, [user]);

  return (
    <AuthContext.Provider value={{ user, logout, account, refreshAccount }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
